<app-week-calendar [loading]="loading" (dateUpdate)="focusDate = $event" [events]="calendarEntries"></app-week-calendar>
